import { urlApiCourse } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponseCanvas } from '~/utils/interface/base';
import {
  IModule,
  ICoursesDetail,
  IQueryGetCoursesOfStudent,
  ICourseSelect,
  IPayloadGetModulesOfCourse,
  IModuleSelect,
  ICourse,
  IQueryGetCourses,
  IPayloadUpdateCourses,
} from '~/utils/interface/course';

export const courseApi = {
  getCourses(params: IQueryGetCourses) {
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<ICourse[]>>>(urlApiCourse.base, { params });
  },

  updateCourses(payload: IPayloadUpdateCourses) {
    return axiosClient.put<IBaseResponse<any>>(urlApiCourse.base, payload);
  },

  getCourseUpcoming() {
    const url = `${urlApiCourse.getCourseUpcoming}`;
    return axiosClient.get<IBaseResponse<IModule[]>>(url);
  },

  getDetailCourse(coursesId: string, lessonId: string) {
    const url = `${urlApiCourse.getDetail(coursesId, lessonId)}`;
    return axiosClient.get<IBaseResponse<ICoursesDetail>>(url);
  },

  getCoursesOfStudent(params: IQueryGetCoursesOfStudent) {
    const url = `${urlApiCourse.getCoursesOfStudent}`;
    return axiosClient.get<IBaseResponse<ICourseSelect[]>>(url, { params });
  },

  getModulesOfCourse(params: IPayloadGetModulesOfCourse) {
    const url = `${urlApiCourse.getModulesOfCourse(params.courseId)}`;
    return axiosClient.get<IBaseResponse<IModuleSelect[]>>(url);
  },
  
  getCoursesDetailOfStudent(studentId: string) {
    return axiosClient.get(`/courses/${studentId}`);
  },
};
